export const PLATFORM_DEFAULT_ASTROLOGER_SLUG = "deepseek-v4-flash"

export function getPlatformDefaultAstrologer(astrologers) {
  if (!Array.isArray(astrologers) || astrologers.length === 0) {
    return null
  }

  return (
    astrologers.find((astrologer) => astrologer?.slug === PLATFORM_DEFAULT_ASTROLOGER_SLUG) ??
    astrologers[0] ??
    null
  )
}

export function getPlatformDefaultAstrologerId(astrologers) {
  return getPlatformDefaultAstrologer(astrologers)?.id ?? ""
}

export function resolveAstrologerSelection(astrologers, preferredAstrologerId) {
  const list = Array.isArray(astrologers) ? astrologers : []

  if (preferredAstrologerId) {
    const preferred = list.find((astrologer) => astrologer?.id === preferredAstrologerId)
    if (preferred) {
      return preferred
    }
  }

  return getPlatformDefaultAstrologer(list)
}
